/* The bag (Carmen, 2026-10-20, as miista.com): the window and the /cart page (snippets/cr-bag.liquid).
   Here: the page behind stays still while the window is open, the open rows stay open after the bag updates,
   "We're also cute" adds a piece, and the promo code. Quantity and remove: Dawn's cart.js. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartUrl = (window.routes && routes.cart_url) || root + 'cart';

  // the page behind stays still (iPhones ignore overflow: hidden): pinned where it was, released on close
  var lockY = 0, locked = false;
  function lock() {
    if (locked) return;
    locked = true; lockY = window.scrollY;
    var b = document.body.style;
    b.position = 'fixed'; b.top = -lockY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, lockY);
  }
  customElements.whenDefined('cart-drawer').then(function () {
    var proto = customElements.get('cart-drawer').prototype;
    var open = proto.open, close = proto.close;
    proto.open = function () { lock(); return open.apply(this, arguments); };
    proto.close = function () { unlock(); return close.apply(this, arguments); };
  });

  // open rows (We're also cute, Promo code) stay open when the bag is redrawn
  var openRows = {};
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.matches && d.matches('details[data-cr-acc]')) openRows[d.dataset.crAcc] = d.open;
  }, true);
  function restoreRows() {
    document.querySelectorAll('details[data-cr-acc]').forEach(function (d) {
      if (openRows[d.dataset.crAcc] && !d.open) d.open = true;
    });
    syncPromo();
  }
  function watch() {
    var mo = new MutationObserver(restoreRows);
    ['cart-drawer', 'cart-items', '#main-cart-footer'].forEach(function (s) {
      var el = document.querySelector(s);
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }

  // redraw the bag window, the /cart page and the header count from the cart as it is now
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function refresh() {
    var drawer = document.querySelector('cart-drawer');
    var items = document.getElementById('main-cart-items');
    var foot = document.getElementById('main-cart-footer');
    var ids = [];
    if (drawer) ids.push('cart-drawer');
    if (items) ids.push(items.dataset.id);
    if (foot) ids.push(foot.dataset.id);
    if (!ids.length) return Promise.resolve();
    return fetch(cartUrl + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (drawer && s['cart-drawer']) {
          var doc = parse(s['cart-drawer']);
          var inner = doc.querySelector('.drawer__inner'), cur = drawer.querySelector('.drawer__inner');
          if (inner && cur) cur.innerHTML = inner.innerHTML;
          drawer.classList.toggle('is-empty', !!doc.querySelector('cart-drawer.is-empty'));
        }
        [items, foot].forEach(function (el) {
          if (!el || !s[el.dataset.id]) return;
          var src = parse(s[el.dataset.id]).querySelector('#' + el.id + ' .js-contents');
          var dst = el.querySelector('.js-contents');
          if (src && dst) dst.innerHTML = src.innerHTML;
          var empty = !!parse(s[el.dataset.id]).querySelector('.is-empty');
          var page = document.querySelector('cart-items');
          if (page) page.classList.toggle('is-empty', empty);
          if (foot) foot.classList.toggle('is-empty', empty);
        });
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  // on the /cart page, the bag window follows the page (Dawn redraws only the page), and the page follows
  // the window and the quick add
  function follow() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return; // Dawn's pubsub: top-level consts, not on window
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      if (document.getElementById('main-cart-items')) refresh();
    });
  }

  // We're also cute: a size (or Add) puts the piece in the bag
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cr-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var all = b.closest('.cr-bag-cute').querySelectorAll('[data-cr-add]');
    all.forEach(function (x) { x.classList.add('is-busy'); });
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.crAdd, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        return refresh();
      })
      .catch(function () {
        all.forEach(function (x) { x.classList.remove('is-busy'); });
        var msg = b.closest('.cr-bag-cute-card').querySelector('.cr-bag-cute-msg');
        if (!msg) { msg = document.createElement('p'); msg.className = 'cr-bag-line cr-bag-cute-msg'; b.parentNode.after(msg); }
        msg.textContent = 'Sorry, this piece could not be added.';
      });
  });

  // Promo code: checked on Shopify's discount link, kept for checkout (stored in this browser)
  var key = 'corazonroto_cart_discount_code';
  function stored() { try { return localStorage.getItem(key) || ''; } catch (e) { return ''; } }
  function store(code) { try { code ? localStorage.setItem(key, code) : localStorage.removeItem(key); } catch (e) {} }
  function syncPromo() {
    var code = stored();
    document.querySelectorAll('[data-promo-code-input]').forEach(function (i) { if (!i.value) i.value = code; });
    document.querySelectorAll('[data-cr-discount]').forEach(function (i) { i.value = code; });
  }
  function where(el) { return el.closest('cart-drawer') ? 'cart-drawer' : '#main-cart-items'; }
  function apply(button) {
    var box = button.closest('[data-cart-drawer-promo]');
    var input = box.querySelector('[data-promo-code-input]');
    var msg = box.querySelector('[data-promo-code-message]');
    var code = input.value.trim();
    var place = where(button);
    function say(text, state) {
      var m = document.querySelector(place + ' [data-promo-code-message]') || msg;
      m.textContent = text; m.dataset.state = state;
      var i = document.querySelector(place + ' [data-promo-code-input]');
      if (i) i.value = code;
    }
    if (!code) { say('Enter a promo code first.', 'error'); return; }
    button.disabled = true;
    var before;
    fetch(root + 'cart.js').then(function (r) { return r.json(); })
      .then(function (c) { before = c; return fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl), { credentials: 'same-origin' }); })
      .then(function () { return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (after) {
        var upper = code.toUpperCase();
        var ok = (after.cart_level_discount_applications || []).some(function (d) { return d.title && d.title.toUpperCase() === upper; })
          || after.total_discount > before.total_discount;
        store(ok ? code : '');
        return refresh().then(function () {
          say(ok ? upper + ' applied.' : upper + " doesn't exist or can't be applied.", ok ? 'success' : 'error');
        });
      })
      .catch(function () { button.disabled = false; say('We could not apply this code. Try again.', 'error'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-promo-code-apply]');
    if (b) { e.preventDefault(); apply(b); }
  });
  document.addEventListener('keydown', function (e) {
    var i = e.target.closest && e.target.closest('[data-promo-code-input]');
    if (!i || e.key !== 'Enter') return;
    e.preventDefault();
    var b = i.closest('[data-cart-drawer-promo]').querySelector('[data-promo-code-apply]');
    if (b) apply(b);
  });
  document.addEventListener('submit', syncPromo, true);

  function start() { syncPromo(); watch(); follow(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
